import React, { useCallback } from 'react';
import { useHierarchicalMenu, useInstantSearch } from 'react-instantsearch';
export default function HierarchicalMenu({ hierarchicalMenuComponent: HierarchicalMenuComponent, menuSettings, routing = null, additionalData, }) {
    const menu = useHierarchicalMenu(menuSettings);
    const { results } = useInstantSearch();
    const customCreateURL = useCallback((value) => {
        if (!routing) {
            return menu.createURL(value);
        }
        if (!menuSettings.hardRefresh) {
            return menu.createURL(value);
        }
        const [attribute] = menuSettings.attributes;
        const { separator } = menuSettings;
        if (routing.pathAttribute !== attribute) {
            return menu.createURL(value);
        }
        const url = new URL(menu.createURL(value));
        url.searchParams.delete('page');
        const mappedValue = value && routing.mapping && routing.mapping[attribute]
            ? routing.mapping[attribute][value] || value
            : value;
        const slug = routing.addToPath && routing.basePath
            ? `/${routing.basePath}/${mappedValue.split(separator).join('/')}`
            : `/${mappedValue.split(separator).join('/')}`;
        return `${(routing.siteUrl || url.origin)}${slug}${routing.addTrailingSlashesToUrls ? '/' : ''}${url.search}${url.hash}`;
    }, [menu, menuSettings, routing]);
    return (React.createElement(HierarchicalMenuComponent, { results: results, menu: menu, menuSettings: menuSettings, createURL: customCreateURL, additionalData: additionalData }));
}
